import { Link } from 'react-router-dom';
const ReportTabs = (props) => {
    return (
            <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
                <li className="nav-item" role="presentation">
                    <Link to={"/gstreport"} className={props.pageName === "GSTREPORT" ? "nav-link active bg-primary text-white" : "nav-link"}>GST REPORT</Link>
                </li>
            </ul>
    );
};

export default ReportTabs;
